import React from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { createPortal } from 'react-dom'

const BusyModal = ({
    title = 'Please wait...',
    centered,
    visible = true
}) => {
    return !visible ? null : createPortal(
        <Modal
            size='sm'
            show
            backdrop='static'
            keyboard={false}
            centered={centered}
        >
            <Modal.Body>
                <Spinner animation="border" size="sm" />
                <span style={{ paddingLeft: '10px'}}>{title}</span>
            </Modal.Body>
        </Modal>
        , document.body)
}

export default BusyModal